// 根据环境不同来创建preview地址

export default uid => {
    if (window.location.href.includes('visualediting/mobile')) {
        return `${window.location.href.split('visualediting')[0]}preview/mobile/${uid}/count__${Date.now()}`;
    } else {
        return `${window.location.href.split('visualediting')[0]}preview/${uid}/count__${Date.now()}`;
    }
};
